import { CombinedTokenStorage } from '../storage';
import { TokenClient } from '../TokenClient';
import { TokenRoutes } from './TokenRoutes';
let userTokenRequest;
let publicTokenRequest;
const getUserAccessToken = async () => {
  const tokenClient = new TokenClient({
    url: TokenRoutes.USER_ACCESS,
    requestOptions: {
      method: 'GET'
    },
    storage: new CombinedTokenStorage()
  });
  userTokenRequest ??= tokenClient.getToken();
  return userTokenRequest;
};
const getPublicAccessToken = async () => {
  const tokenClient = new TokenClient({
    url: TokenRoutes.PUBLIC_ACCESS,
    requestOptions: {
      method: 'GET'
    },
    storage: new CombinedTokenStorage()
  });
  publicTokenRequest ??= tokenClient.getToken();
  return publicTokenRequest;
};

/**
 * This component adds compatibility layer to old SPAs taking token from object on window provided by Online layout.
 * We shouldn't need this in the future, SPAs should use dedicated react token providers.
 * @deprecated Use `UniversalTokenProvider`/`PrefetchedTokenProvider`/`StandaloneTokenProvider` with `useToken` hook
 */
export const LegacyTokenService = () => {
  if (typeof window !== 'undefined' && !window.ori?.tokenService) {
    window.ori = {
      ...window.ori,
      tokenService: {
        getToken: getUserAccessToken,
        getPublicToken: getPublicAccessToken
      }
    };
  }
  return null;
};
//# sourceMappingURL=LegacyTokenService.js.map